<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  count: { type: Number, required: true },
  alignBottom: { type: Boolean, default: false },
});

const { t } = useI18n();

const displayCount = computed(() =>
  props.count > 9 ? t('CHAT_LIST.UNREAD_COUNT_OVERFLOW') : props.count
);
</script>

<template>
  <!-- BonBoZ: chữ số không có đuôi dưới nên căn giữa theo khối em bị lệch
       lên; pt-px kéo lại. -->
  <span
    v-if="count > 0"
    class="bg-n-ruby-9 rounded-full h-4 min-w-4 max-w-5 2xl:h-[18px] 2xl:min-w-[18px] 2xl:max-w-6 3xl:h-5 3xl:min-w-5 3xl:max-w-7 px-1 w-fit font-medium text-xxs 2xl:text-[0.6875rem] 3xl:text-xs leading-none text-white inline-flex items-center justify-center flex-shrink-0 pt-px tabular-nums"
    :class="{
      'mb-0.5': alignBottom,
    }"
  >
    {{ displayCount }}
  </span>
  <span v-else />
</template>
